<sui-dialog-simple [(error)]="apiError">
  <ng-template suiDialogHeader>
    @if (objectIcon) {
      <fa-icon [icon]="objectIcon"></fa-icon>
    }
    <h2 ngpDialogTitle>{{ objectTitle }}</h2>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <app-alert-editor #alertEditor [alert]="alert"></app-alert-editor>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button size="md" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button
      size="md"
      variant="primary"
      [disabled]="!isValid()"
      [loading]="saving()"
      (click)="save()"
    >
      {{ "btn.save" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
